<!-- 停车场剩余车位上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "cmd": "reportParkRemainCarport",
          "lastUpdateTime": "20220308173726",
          "normalPermitCount": 80,
          "normalRemainCount": 0,
          "parkCode": "123456",
          "totalPermitCount": 80,
          "totalRemainCount": 0
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报车场实时剩余车位信息到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportParkRemainCarport",
          precondition: "无",
          fitSystem: "VEMS传统车场,云停车场, 路边车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '否',
                info3: 'String',
                info4: '停车场编号'
              },
              {
                info1: 'totalRemainCount',
                info2: '是',
                info3: 'Integer',
                info4: '总剩余车位数'
              },
              {
                info1: 'totalPermitCount',
                info2: '是',
                info3: 'Integer',
                info4: '总车位数'
              },
              {
                info1: 'normalPermitCount',
                info2: '否',
                info3: 'Integer',
                info4: '临时车位数'
              },
              {
                info1: 'normalRemainCount',
                info2: '否',
                info3: 'Integer',
                info4: '剩余临时车位数'
              },
              {
                info1: 'lastUpdateTime',
                info2: '否',
                info3: 'String',
                info4: '最近更新时间：yyyyMMddHHmmss'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportParkRemainCarport.vue